import { Colors } from '../../../../themes/colors';

export const FormCard = ({
  title,
  headerRight,
  required,
  children,
  style = {},
  titleStyle = {},
  contentStyle = {},
}) => (
  <div
    className="card"
    style={{
      width: '100%',
      padding: '20px 20px 40px 20px',
      ...style,
    }}
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        marginBottom: title || headerRight ? 24 : 0,
      }}
    >
      {title && (
        <span
          style={{
            color: Colors.neutral_600,
            fontSize: 24,
            fontWeight: 600,
            textAlign: 'center',
            ...titleStyle,
          }}
        >
          {title}
          {required && <span style={{ color: Colors.error_500 }}>*</span>}
        </span>
      )}

      <div
        style={{
          position: 'absolute',
          right: 0,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        {headerRight}
      </div>
    </div>

    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '95%',
        alignSelf: 'center',
        gap: 24,
        ...contentStyle,
      }}
    >
      {children}
    </div>
  </div>
);
